function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { render } from "rc-util/es/React/render";
import * as React from 'react';
import ConfigProvider, { globalConfig, warnContext } from '../config-provider';
import PurePanel from './PurePanel';
import useMessage, { useInternalMessage } from './useMessage';
import { wrapPromiseFn } from './util';
var message = null;

var act = function act(callback) {
  return callback();
};

var taskQueue = [];
var defaultGlobalConfig = {};

function getGlobalContext() {
  var _defaultGlobalConfig = defaultGlobalConfig,
      globalPrefixCls = _defaultGlobalConfig.prefixCls,
      globalGetContainer = _defaultGlobalConfig.getContainer,
      duration = _defaultGlobalConfig.duration,
      rtl = _defaultGlobalConfig.rtl,
      maxCount = _defaultGlobalConfig.maxCount,
      top = _defaultGlobalConfig.top;
  var mergedPrefixCls = globalPrefixCls !== null && globalPrefixCls !== void 0 ? globalPrefixCls : globalConfig().getPrefixCls('message');
  var mergedContainer = (globalGetContainer === null || globalGetContainer === void 0 ? void 0 : globalGetContainer()) || document.body;
  return {
    prefixCls: mergedPrefixCls,
    container: mergedContainer,
    duration: duration,
    rtl: rtl,
    maxCount: maxCount,
    top: top
  };
}

var GlobalHolder = /*#__PURE__*/React.forwardRef(function (_, ref) {
  var initializeMessageConfig = function initializeMessageConfig() {
    var _getGlobalContext = getGlobalContext(),
        prefixCls = _getGlobalContext.prefixCls,
        container = _getGlobalContext.container,
        maxCount = _getGlobalContext.maxCount,
        duration = _getGlobalContext.duration,
        rtl = _getGlobalContext.rtl,
        top = _getGlobalContext.top;

    return {
      prefixCls: prefixCls,
      getContainer: function getContainer() {
        return container;
      },
      maxCount: maxCount,
      duration: duration,
      rtl: rtl,
      top: top
    };
  };

  var _React$useState = React.useState(initializeMessageConfig),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      messageConfig = _React$useState2[0],
      setMessageConfig = _React$useState2[1];

  var _useInternalMessage = useInternalMessage(messageConfig),
      _useInternalMessage2 = _slicedToArray(_useInternalMessage, 2),
      api = _useInternalMessage2[0],
      holder = _useInternalMessage2[1];

  var global = globalConfig();
  var rootPrefixCls = global.getRootPrefixCls();
  var rootIconPrefixCls = global.getIconPrefixCls();

  var sync = function sync() {
    setMessageConfig(initializeMessageConfig);
  };

  React.useEffect(sync, []);
  React.useImperativeHandle(ref, function () {
    var instance = Object.assign({}, api);
    Object.keys(instance).forEach(function (method) {
      instance[method] = function () {
        sync();
        return api[method].apply(api, arguments);
      };
    });
    return {
      instance: instance,
      sync: sync
    };
  });
  return /*#__PURE__*/React.createElement(ConfigProvider, {
    prefixCls: rootPrefixCls,
    iconPrefixCls: rootIconPrefixCls
  }, holder);
});

function flushNotice() {
  if (!message) {
    var holderFragment = document.createDocumentFragment();
    var newMessage = {
      fragment: holderFragment
    };
    message = newMessage; // Delay render to avoid sync issue

    act(function () {
      render( /*#__PURE__*/React.createElement(GlobalHolder, {
        ref: function ref(node) {
          var _ref = node || {},
              instance = _ref.instance,
              sync = _ref.sync; // React 18 test env will throw if call immediately in ref


          Promise.resolve().then(function () {
            if (!newMessage.instance && instance) {
              newMessage.instance = instance;
              newMessage.sync = sync;
              flushNotice();
            }
          });
        }
      }), holderFragment);
    });
    return;
  } // Notification not ready


  if (!message.instance) {
    return;
  } // >>> Execute task


  taskQueue.forEach(function (task) {
    var type = task.type,
        skipped = task.skipped; // Only `skipped` when user call notice but cancel it immediately
    // and instance not ready

    if (!skipped) {
      switch (type) {
        case 'open':
          {
            act(function () {
              var closeFn = message.instance.open(Object.assign(Object.assign({}, defaultGlobalConfig), task.config));
              closeFn === null || closeFn === void 0 ? void 0 : closeFn.then(task.resolve);
              task.setCloseFn(closeFn);
            });
            break;
          }

        case 'destroy':
          act(function () {
            message === null || message === void 0 ? void 0 : message.instance.destroy(task.key);
          });
          break;
        // Other type open

        default:
          {
            act(function () {
              var _message$instance;

              var closeFn = (_message$instance = message.instance)[type].apply(_message$instance, _toConsumableArray(task.args));

              closeFn === null || closeFn === void 0 ? void 0 : closeFn.then(task.resolve);
              task.setCloseFn(closeFn);
            });
          }
      }
    }
  }); // Clean up

  taskQueue = [];
} // ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================


function setMessageGlobalConfig(config) {
  defaultGlobalConfig = Object.assign(Object.assign({}, defaultGlobalConfig), config); // Trigger sync for it

  act(function () {
    var _a;

    (_a = message === null || message === void 0 ? void 0 : message.sync) === null || _a === void 0 ? void 0 : _a.call(message);
  });
}

function open(config) {
  var result = wrapPromiseFn(function (resolve) {
    var closeFn;
    var task = {
      type: 'open',
      config: config,
      resolve: resolve,
      setCloseFn: function setCloseFn(fn) {
        closeFn = fn;
      }
    };
    taskQueue.push(task);
    return function () {
      if (closeFn) {
        act(function () {
          closeFn();
        });
      } else {
        task.skipped = true;
      }
    };
  });
  flushNotice();
  return result;
}

function typeOpen(type, args) {
  // Warning if exist theme
  if (process.env.NODE_ENV !== 'production') {
    warnContext('message');
  }

  var result = wrapPromiseFn(function (resolve) {
    var closeFn;
    var task = {
      type: type,
      args: args,
      resolve: resolve,
      setCloseFn: function setCloseFn(fn) {
        closeFn = fn;
      }
    };
    taskQueue.push(task);
    return function () {
      if (closeFn) {
        act(function () {
          closeFn();
        });
      } else {
        task.skipped = true;
      }
    };
  });
  flushNotice();
  return result;
}

function destroy(key) {
  taskQueue.push({
    type: 'destroy',
    key: key
  });
  flushNotice();
}

var methods = ['success', 'info', 'warning', 'error', 'loading'];
var baseStaticMethods = {
  open: open,
  destroy: destroy,
  config: setMessageGlobalConfig,
  useMessage: useMessage,
  _InternalPanelDoNotUseOrYouWillBeFired: PurePanel
};
var staticMethods = baseStaticMethods;
methods.forEach(function (type) {
  staticMethods[type] = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return typeOpen(type, args);
  };
}); // ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================

var noop = function noop() {};
/** @private Only Work in test env */
// eslint-disable-next-line import/no-mutable-exports


export var actWrapper = noop;

if (process.env.NODE_ENV === 'test') {
  actWrapper = function actWrapper(wrapper) {
    act = wrapper;
  };
}
/** @private Only Work in test env */
// eslint-disable-next-line import/no-mutable-exports


export var actDestroy = noop;

if (process.env.NODE_ENV === 'test') {
  actDestroy = function actDestroy() {
    message = null;
  };
}

export default staticMethods;